<div class="widget widget-datepicker-range">
    <div>
        <input
            #dateElementStart
            readonly
            type="text"
            (ngModelChange)="onDateChangeStart($event)"
            [required]="required ? true : false"
            [name]="name + '-start'"
            [disabled]="disabled"
            [min]="getMinStart()"
            [max]="getMaxStart()"
            [placeholder]="placeholderStart"
            [matDatepicker]="datepickerStart"
            [(ngModel)]="date.start"
            (mousedown)="datepickerStart.open()">

        <a *ngIf="resetable && date.start" class="widget-clear" (click)="onClearClick('START')"><i class="i i-cross-circle"></i></a>
    </div>

    <div>→</div>

    <div>
        <input
            #dateElementEnd
            readonly
            type="text"
            (ngModelChange)="onDateChangeEnd($event)"
            [required]="required ? true : false"
            [name]="name + '-end'"
            [disabled]="disabled"
            [min]="getMinEnd()"
            [max]="getMaxEnd()"
            [placeholder]="placeholderEnd"
            [matDatepicker]="datepickerEnd"
            [(ngModel)]="date.end"
            (mousedown)="datepickerEnd.open()">

        <a *ngIf="resetable && date.end" class="widget-clear" (click)="onClearClick('END')"><i class="i i-cross-circle"></i></a>
        <i class="widget-icon i i-calendar"></i>
    </div>

    <mat-datepicker #datepickerStart [dateClass]="rangeDateClass"></mat-datepicker>
    <mat-datepicker #datepickerEnd [dateClass]="rangeDateClass"></mat-datepicker>
</div>
